import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";

import { LocaleProvider } from "antd";
import deDE from "antd/lib/locale-provider/de_DE";

ReactDOM.render(
  <LocaleProvider locale={deDE}>
    <Router>
      <App />
    </Router>
  </LocaleProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
